module.exports = __webpack_public_path__ + "static/pic02-ce910a45c05efb9ddefbf2f9aa5565ab.jpg";